(() => {
  const labelSliderDots = (container) => {
      const dots = container.querySelectorAll('button.hdt-slider__dot');

      dots.forEach((dot, index) => {
        if (!dot.hasAttribute('aria-label')) {
          dot.setAttribute(
            'aria-label',
            `Go to slide ${index + 1} of ${dots.length}`
          );
        }

        if (dot.classList.contains('hdt-slider__dot--selected')) {
          if (dot.getAttribute('aria-current') !== 'true') dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
  };

  const pending = new Set();
  let frame;
  const schedule = (container) => {
    pending.add(container);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      pending.forEach((item) => {
        if (item.isConnected) labelSliderDots(item);
      });
      pending.clear();
    });
  };
  const discover = (root) => {
    if (!(root instanceof Element)) return;
    const container = root.closest('.hdt-slider__dots');
    if (container) schedule(container);
    root.querySelectorAll('.hdt-slider__dots').forEach(schedule);
  };
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        const container = mutation.target.closest('.hdt-slider__dots');
        if (container) schedule(container);
      } else {
        const container = mutation.target.closest?.('.hdt-slider__dots');
        if (container) schedule(container);
        mutation.addedNodes.forEach(discover);
      }
    });
  });

  const start = () => {
    document.querySelectorAll('.hdt-slider__dots').forEach(labelSliderDots);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
